module.exports = __webpack_public_path__ + "static/img/abimg8.7c2845e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/abimg8.png
// module id = kO89
// module chunks = 1